<template>
	<vxe-modal v-model="showFlag" title="大表同环比分析" :mask="false":lock-view="false" show-zoom resize
						:destroy-on-close="true" fullscreen remember :esc-closable="false">
		<div class="actDiv">
			<label style="font-size: 0.8rem;">给水号：</label>
			<a-input style="width: 10.5rem;" v-model="theApid" ></a-input>
			<label style="font-size: 0.8rem;margin-left: 0.625rem;">日期：</label>
			<a-range-picker  style="font-size: 0.6875rem;width: 15rem;" v-model="theDateList"
							format="YYYY-MM-DD" @change="onDateChange" size="small">
			</a-range-picker>
			<a-select style="width:5.5rem;  font-size: 0.6875rem;margin-left: 0.625rem;" v-model="theType"  >
				<a-select-option v-for="item in typeList" :key="item.index" :value="item.index">
					{{item.name}}
				</a-select-option>
			</a-select>
			<a-button size="small"   icon="search" @click="doQuery()" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
			<a-button size="small"   icon="download" @click="doExport()" :loading="loading">导出</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="dataList" bordered :loading="loading"
						rowKey="id" :pagination="false" :scroll="{y:600}" :hideOnSinglePage="false">
			<a-button slot="action" slot-scope="text, record"  type="link"
							@click="drawCharts(record)"  :disabled="record.thisFlow == '--' || record.lastFlow == '--'">
						流量图形分析
			</a-button>
		</a-table>
		<MeterMonitorYoYStatisView ref="statisView" />
	</vxe-modal>
</template>

<script>
	import MeterMonitorYoYStatisView from '/src/components/MeterMonitorYoYStatisView.vue'
	const columns = [
		{
			title: '给水号',
			dataIndex: 'meterApid',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点名称',
			dataIndex: 'monitorName',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点地址',
			dataIndex: 'monitorAddress',
			width:240,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '口径',
			dataIndex: 'caliber',
			width:90,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '本期流量',
			dataIndex: 'thisFlow',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '对比流量',
			dataIndex: 'lastFlow',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '波动(%)',
			dataIndex: 'ratio',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '流量图形分析',
			dataIndex: 'id',
			width:120,
			className:'v-cell',
			scopedSlots:{customRender:'action'},
			align:'center',
		},
	];
	export default {
		components: {
			MeterMonitorYoYStatisView,
		},
		data(){
			return {
				columns,
				theType:1,
				showDrawer:false,
				loading:false,
				showFlag:false,
				theApid:null,
				dateStart:null,
				dateEnd:null,
				theDateList:[],
				dataList:[],
				typeList:[
					{
						name:'同比',
						index:1,
					},
					{
						name:'环比',
						index:2,
					},
					{
						name:'自定义',
						index:3,
					}
				],
			}
		},
		methods:{
			onDateChange(date, dateString) {
				this.dateStart=dateString[0];
				this.dateEnd=dateString[1];
			},
			showView(){
				this.showFlag = true;
			},
			doQuery(){
				if(this.dateStart == null  || this.dateEnd == null || this.theDateList.length == 0){
					this.$message.error("请选择开始日期和结束日期");
					return;
				}
				this.loading = true;
				let param = {
					apId:this.theApid,
					type:this.theType,
					beginDate:this.dateStart,
					endDate:this.dateEnd,
				}
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_YOY_STATIS_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			doExport(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_YOY_STATIS_EXPORT_URL);
				let param = {
					apId:this.theApid,
					type:this.theType,
					beginDate:this.dateStart,
					endDate:this.dateEnd,
				}
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.loading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '大表同环比分析'+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			drawCharts(row){
				this.$refs.statisView.showView(row,this.dateStart,this.dateEnd,this.theType);
			},
		},
	}
</script>

<style>
</style>
